import {apiUrl} from '../utils/constants';
import {GET, POST, PUT, DELETE} from './api.service.wrapper';

export const GetCharities = async (page = '', perPage = '', keyword = '') => {
    let params = {};

    if (page) {
        params['page'] = page;
    }

    if (perPage) {
        params['per-page'] = perPage;
    }

    if (keyword) {
        params['keyword'] = keyword;
    }

    return await GET(apiUrl.charities, params);
}

export const GetCharitiesById = async (id) => {
    return  await GET(apiUrl.charities + '/' + id);
}

export const CreateCharities= async (data) => {
    const config = {
        headers: {
            'content-type': 'multipart/form-data'
        }
    }
    return await POST(apiUrl.charities, data, config);
}

export const UpdateCharities = async (id, data) => {
    const config = {
        headers: {
            'content-type': 'multipart/form-data'
        }
    }
    return await PUT(apiUrl.charities, id, data, config);
}

export const DeleteCharities = async (id) => {
    return await DELETE(apiUrl.charities, id);
}

export const DeleteAllCharities = async (ids) => {
    return await POST(apiUrl.delete_all_charities, ids);
}
